export enum SLICE_NAMES {
	USERS = "USERS",
	ITE = "ITE",
	PORTFOLIO = "PORTFOLIO",
}
